var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 43,
    viewBox: "0 0 63 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_2785)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M0 42.1833V19.6882L8.2822 13.0424V42.1826L0 42.1833ZM22.3688 12.2246C15.0424 12.2246 9.09582 19.12 9.09582 27.6125C9.09659 36.1073 15.0432 43.0003 22.3688 43.0003C29.6945 43.0003 35.6411 36.1065 35.6411 27.6125C35.6411 19.12 29.6945 12.2246 22.3688 12.2246ZM22.3688 35.5022C19.1482 35.5022 16.5644 31.9486 16.5644 27.5779C16.5644 23.2065 19.1482 19.6529 22.3688 19.6529C25.5895 19.6529 28.1733 23.2065 28.1733 27.5771C28.1733 31.9486 25.5895 35.5022 22.3688 35.5022ZM49.7623 12.2246C42.4366 12.2246 36.4908 19.12 36.4908 27.6125C36.4901 36.1073 42.4359 43.0003 49.7623 43.0003C57.0895 43.0003 63 36.1065 63 27.6125C63 19.12 57.0534 12.2246 49.7623 12.2246ZM49.7623 35.5022C46.5424 35.5022 43.9586 31.9486 43.9586 27.5779C43.9586 23.2065 46.5424 19.6529 49.7631 19.6529C52.9838 19.6529 55.5675 23.2065 55.5675 27.5771C55.5675 31.9486 52.9477 35.5014 49.7631 35.5014L49.7623 35.5022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7567 0.568359H20.1368V9.95004H22.7567V0.568359ZM5.69676 7.21416L2.79492 9.70202V0.568359H5.69676V7.21416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5445 0.568359H20.7401V3.05622H26.5445V0.568359ZM8.2822 0.568359H0V2.84275H8.2822V0.568359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6314 0.568214H25.8002V9.94989H28.6314V0.568214ZM14.0131 0C11.1819 0 8.88086 2.30971 8.88086 5.15232C8.88086 7.9957 11.1819 10.3062 14.0131 10.3062C16.845 10.3062 19.1453 7.9957 19.1453 5.15309C19.1453 2.30971 16.845 0 14.0131 0ZM14.0131 7.81832C12.6332 7.81832 11.5361 6.60971 11.5361 5.15309C11.5361 3.6957 12.6332 2.48786 14.0131 2.48786C15.3937 2.48786 16.4908 3.6957 16.4908 5.15232C16.4908 6.60971 15.3937 7.81832 14.0131 7.81832Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_2785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop100);
export default __webpack_public_path__ + "static/media/top100.96ea2925ce86a42308a74de93c5306d4.svg";
export { ForwardRef as ReactComponent };